import { gql } from '@apollo/client';

export const DELETE_ADDRESS = gql`
  mutation DELETE_ADDRESS($id: ID!) {
    opsShippingAddress(id: $id) {
      address: delete
    }
  }
`;
